import config from "../config";
import { sendPostRequest, sendGetRequest } from "../Utility/FetchUtils";
import { TemperatureLog, ModuleTemperatureSensor, TemperatureReading, ETemperatureControlFeature } from "../Model/Temperature";
import DateUtil from "../Utility/DateUtil";
import { DateRange } from "../Model/Date";

class TemperatureApi {
  static BASE_URL = config.SERVICE_URL + "/temperature";

  static getOAvailableTemperatureDataDates(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/data/" + moduleIdentifier + "/dates";
    return sendGetRequest<string[]>(url);
  }

  static setTargetTemperature(moduleIdentifier: string, targetTemperature: number) {
    const url = TemperatureApi.BASE_URL + "/target/" + moduleIdentifier + "/" + targetTemperature;
    return sendPostRequest(url);
  }

  static getTargetTemperature(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/target/" + moduleIdentifier;
    return sendGetRequest<number>(url);
  }

  static getCurrentTemperature(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/current/" + moduleIdentifier;
    return sendGetRequest<number>(url);
  }

  static getTemperatureControlFeatures(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/feature/" + moduleIdentifier;
    return sendGetRequest<ETemperatureControlFeature[]>(url);
  }

  static getTemperatureSensors() {
    const url = TemperatureApi.BASE_URL + "/sensor";
    return sendGetRequest<ModuleTemperatureSensor[]>(url);
  }

  static getTemperatureLog(moduleIdentifier: string, dateRange: DateRange) {
    const url =
      TemperatureApi.BASE_URL +
      "/data/" +
      moduleIdentifier +
      "/" +
      DateUtil.toString(dateRange.start) +
      "/" +
      DateUtil.toString(dateRange.end);
    return sendGetRequest<TemperatureLog>(url);
  }

  static async getTemperatureReading(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/reading/" + moduleIdentifier;
    return sendGetRequest<TemperatureReading[]>(url);
  }

  static clearFanError(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/" + moduleIdentifier + "/:clear-fan-error";
    return sendPostRequest(url);
  }

  static clearHeaterError(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/" + moduleIdentifier + "/:clear-heater-error";
    return sendPostRequest(url);
  }

  static clearTemperatureViolation(moduleIdentifier: string) {
    const url = TemperatureApi.BASE_URL + "/" + moduleIdentifier + "/:clear-temperature-violation";
    return sendPostRequest(url);
  }
}

export default TemperatureApi;
